import React, { useState, useEffect, useRef, useCallback } from "react";
import Sidebar from "../../Component/Sidebar";
import { Button, Modal } from "antd";
import IMAGES from "../../constants/images";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useDispatch, useSelector } from "react-redux";
import AppointmentCounter from "../../Component/AppointmentCounter";
import UpcomingSchedule from "../../Component/UpcomingSchedule";
import TabSwitcher from "../../Component/TabSwitcher";
import ViewSwitcher from "../../Component/ViewSwitcher";
import AppointmentControls from "../../Component/AppointmentFilter";
import AppoinmentView from "../../Component/AppoinmentView";
import FollowupView from "../../Component/FollowupView";
import { getAppointment, getFollowUpAppointment } from "../../redux/action/Appointment";
import NoAppointments from "../../Component/NoAppointment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { checkFiveMinBeforeTime, getRemainingTime, getStatusText } from "../../utils";
import { getPathSegment } from "../../utils/navigation";
export default function Index() {
  const dispatch = useDispatch();
  const aid = getPathSegment(2);
  const [sortClicked, setSortClicked] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const { data } = useSelector((state) => state.GET_APPOINTMENT);
  const { data: followUpData } = useSelector((state) => state.GET_FOLLOW_UP_APPOINTMENT);
  const [activeTab, setActiveTab] = useState("Appointments");
  const [activeView, setActiveView] = useState("grid");
  const [selectedType, setSelectedType] = useState(
    aid === "upcoming" || aid.includes("date") ? "upcoming" : "past"
  );
  const [filteredAppointment, setFilteredAppointment] = useState([]);
  const [filteredFollowUpAppointment, setFilteredFollowUpAppointment] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const visibleDataRef = useRef({ appointmentList: [], paginatedList: [] });

  const handleVisibleDataChange = useCallback((visibleList, pageList) => {
    visibleDataRef.current = { appointmentList: visibleList, paginatedList: pageList };
  }, []);

  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [dataRange, setDataRange] = useState("current"); // "current" | "all"
  const [exportFormat, setExportFormat] = useState("xlsx"); // "xlsx" | "csv" | "pdf"

  // function to toggle sort click state
  const handleSortClick = () => {
    setSortClicked((prev) => !prev); // toggle state on each click
  };

  const handleExportConfirm = () => {
    try {
      console.log("handleExportConfirm called");
      console.log("dataRange:", dataRange);
      console.log("exportFormat:", exportFormat);
      console.log("visibleDataRef.current:", visibleDataRef.current);

      let targetList = [];
      if (dataRange === "current") {
        targetList = visibleDataRef.current.paginatedList || [];
      } else if (dataRange === "selected") {
        const fullList = visibleDataRef.current.appointmentList || [];
        targetList = fullList.filter((item) =>
          selectedRows.includes(item.appointmentId)
        );
      } else {
        targetList = visibleDataRef.current.appointmentList || [];
      }

      console.log("targetList:", targetList);

      if (!targetList || targetList.length === 0) {
        console.warn("Export targetList is empty or undefined");
        if (dataRange === "selected") {
          alert("No selected appointments found to export. Please select at least one appointment in the table.");
        } else {
          alert("No data available to export. Please ensure appointments are loaded in the table.");
        }
        setIsExportModalOpen(false);
        return;
      }

      const selectedData = targetList.map((item) => ({
        appointmentId: item.appointmentId,
        mode: item.mode,
        status: getStatusText(item.status, item.currentStatus),
        date: item.date,
        timeSlot: item.startTime + " - " + item.endTime,
        patiendId: item.clientId,
        patiendName: item.firstName + (item.lastName ? ` ${item.lastName}` : ""),
        risk: item.riskStatus || "N/A",
      }));

      console.log("formatted selectedData:", selectedData);

      if (exportFormat === "xlsx") {
        const worksheet = XLSX.utils.json_to_sheet(selectedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `appointments_${dataRange}.xlsx`);
      } else if (exportFormat === "csv") {
        const worksheet = XLSX.utils.json_to_sheet(selectedData);
        const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
        const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, `appointments_${dataRange}.csv`);
      } else if (exportFormat === "pdf") {
        const doc = new jsPDF();
        doc.setFont("helvetica", "normal");
        doc.text("Appointments Report", 14, 15);
        autoTable(doc, {
          startY: 20,
          head: [["Appt ID", "Mode", "Status", "Date", "Time Slot", "Patient ID", "Patient Name", "Risk"]],
          body: selectedData.map((item) => [
            item.appointmentId,
            item.mode,
            item.status,
            item.date,
            item.timeSlot,
            item.patiendId,
            item.patiendName,
            item.risk,
          ]),
          styles: { font: "helvetica", fontSize: 9 },
          headStyles: { fillColor: [11, 79, 159] }, // matching the #4B61FF color
        });
        doc.save(`appointments_${dataRange}.pdf`);
      }
    } catch (err) {
      console.error("Export error caught:", err);
      alert("Error generating export file: " + err.message);
    }

    setIsExportModalOpen(false);
  };

  // Fetch data on mount and when tab changes
  useEffect(() => {
    const payload = {};
    if (activeTab === "Appointments") {
      dispatch(getAppointment(payload));
    } else {
      dispatch(getFollowUpAppointment(payload));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const parseLocalDateTime = (dateStr, timeStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const [hour, minute, second] = timeStr.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  };

  const now = new Date();
  const hasData = data && Object.keys(data).length > 0;

  const appointmentList = hasData
    ? Object.entries(data)
      .flatMap(([date, appointments]) =>
        appointments
          .map((appt) => {
            const fullDateTime = parseLocalDateTime(appt.date, appt.endTime);
            return {
              ...appt,
              normalizedStatus:
                appt.status === "SCHEDULED" ? "UPCOMING" : appt.status,
              fullDateTime,
            };
          })
          .filter(
            (appt) =>
              appt.normalizedStatus === "UPCOMING" && appt.fullDateTime > now
          )
      )
      .sort((a, b) => a.fullDateTime - b.fullDateTime)
      .slice(0, 1)
    : [];

  console.log("appointmentList", appointmentList);

  useEffect(() => {
    setFilteredAppointment(data);
  }, [data]);

  useEffect(() => {
    setFilteredFollowUpAppointment(followUpData);
  }, [followUpData]);

  useEffect(() => {
    if (aid === "did_not_joined") {
      setSelectedType("past");
      setSelectedStatus("MISSED");
    }
  }, [aid]);

  return (
    <div className="flex bg-[#F8FAFC] min-h-screen mt-[80px] ">
      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] rounded-2xl">
          {/* Header */}
          <div className="max-w mx-auto p-2 mb-1">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
              <div>
                <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
                  Appointment
                </h1>
                <p className="text-xs text-[#64748B] font-poppins mt-0.5 mb-0">
                  Track your sessions, follow-ups and patient activity.
                </p>
              </div>
              {(activeTab === "Appointments" ? filteredAppointment : filteredFollowUpAppointment) &&
              Object.keys(activeTab === "Appointments" ? filteredAppointment || {} : filteredFollowUpAppointment || {}).length > 0 ? (
                <Button
                  onClick={() => setIsExportModalOpen(true)}
                  className="flex items-center gap-2 px-[14px] py-0 bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition h-9 hover:text-[#171717]"
                >
                  Export
                  <img
                    src={IMAGES.export_icon}
                    alt="export_icon"
                    className="w-[16px]"
                  />
                </Button>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-3 p-2">
            {/* Left Side */}
            <div className="flex-1 min-w-0 lg:flex-initial lg:w-[720px]">
              <div className="mt-0 h-full">
                <AppointmentCounter filteredAppointment={activeTab === "Appointments" ? data : followUpData} />
              </div>
            </div>

            {/* Right Side */}
            <div className="w-full lg:flex-1 lg:min-w-[320px] mt-0 p-0">
              {hasData && appointmentList.length > 0 ? (
                <UpcomingSchedule
                  item={appointmentList}
                  avatar={appointmentList[0].imageURL}
                  name={`${appointmentList[0].firstName} ${appointmentList[0].lastName === null
                    ? ``
                    : ` ${appointmentList[0].lastName}`
                    }`}
                  mode={appointmentList[0].mode}
                  time={getRemainingTime(
                    appointmentList[0].date + "T" + appointmentList[0].startTime
                  )}
                  risk={
                    appointmentList[0]?.riskStatus === null
                      ? "NA"
                      : appointmentList[0]?.riskStatus
                  }
                  showJoinNow={checkFiveMinBeforeTime(
                    appointmentList[0].date + "T" + appointmentList[0].startTime
                  )}
                />
              ) : (
                <div className="bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm h-full flex items-center justify-center">
                  <NoAppointments compact />
                </div>
              )}
            </div>
          </div>
          {/* Tabs */}

          <div className="flex justify-between p-2 mt-1 items-center gap-2">
            <TabSwitcher activeTab={activeTab} setActiveTab={setActiveTab} />
            <ViewSwitcher
              activeView={activeView}
              setActiveView={setActiveView}
            />
          </div>

          <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-1 mb-2" />
          {/* Filters */}
          <AppointmentControls
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            setFilteredAppointment={activeTab === "Appointments" ? setFilteredAppointment : setFilteredFollowUpAppointment}
            filteredAppointment={activeTab === "Appointments" ? data : followUpData}
            selectedStatusProp={selectedStatus}
            setSelectedStatusProp={setSelectedStatus}
            selectedRows={selectedRows}
            onSortClick={handleSortClick}
            activeTab={activeTab}
          />
          <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-0 mb-1" />
          {activeTab === "Appointments" ? (
            <AppoinmentView
              activeView={activeView}
              selectedType={selectedType}
              setFilteredAppointment={setFilteredAppointment}
              filteredAppointment={filteredAppointment}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              sortClicked={sortClicked}
              onVisibleDataChange={handleVisibleDataChange}
            />
          ) : (
            <FollowupView
              activeView={activeView}
              selectedType={selectedType}
              setFilteredFollowUpAppointment={setFilteredFollowUpAppointment}
              filteredFollowUpAppointment={filteredFollowUpAppointment}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              sortClicked={sortClicked}
              onVisibleDataChange={handleVisibleDataChange}
            />
          )}
        </div>
      </div>

      <Modal
        open={isExportModalOpen}
        onCancel={() => setIsExportModalOpen(false)}
        footer={null}
        width={480}
        closeIcon={<span className="text-xl text-gray-400 font-poppins hover:text-gray-600">×</span>}
        centered
      >
        <div className="p-2">
          {/* Header */}
          <h2 className="text-2xl font-bold text-[#171717] font-poppins">Export Records</h2>
          <p className="text-[#8E8E8E] text-sm mt-1 mb-4 font-poppins">
            Easily download selected members in your preferred format.
          </p>

          <div className="border-t border-[#E2E8F0] my-4" />

          {/* Section 1: Select Data Range */}
          <h3 className="text-base font-semibold text-[#171717] font-poppins mb-3">Select Data Range</h3>
          <div className="flex gap-6 mb-4 flex-wrap">
            <label className="flex items-center gap-2 cursor-pointer font-poppins text-sm text-[#45413C]">
              <input
                type="radio"
                name="dataRange"
                checked={dataRange === "current"}
                onChange={() => setDataRange("current")}
                className="w-4 h-4 accent-[#4B61FF]"
              />
              Current page
            </label>
            <label className="flex items-center gap-2 cursor-pointer font-poppins text-sm text-[#45413C]">
              <input
                type="radio"
                name="dataRange"
                checked={dataRange === "all"}
                onChange={() => setDataRange("all")}
                className="w-4 h-4 accent-[#4B61FF]"
              />
              All data
            </label>
            <label className="flex items-center gap-2 cursor-pointer font-poppins text-sm text-[#45413C]">
              <input
                type="radio"
                name="dataRange"
                checked={dataRange === "selected"}
                onChange={() => setDataRange("selected")}
                className="w-4 h-4 accent-[#4B61FF]"
              />
              Selected data
            </label>
          </div>

          <div className="border-t border-[#E2E8F0] my-4" />

          {/* Section 2: Choose Format */}
          <h3 className="text-base font-semibold text-[#171717] font-poppins mb-1">Choose Format</h3>
          <p className="text-[#8E8E8E] text-sm mb-4 font-poppins">
            Choose the format that suits your reporting or analysis needs.
          </p>
          <div className="grid grid-cols-3 gap-3 mb-6">
            {[
              { key: "xlsx", label: "Excel (.xlsx)" },
              { key: "csv", label: "CSV (.csv)" },
              { key: "pdf", label: "PDF (.pdf)" },
            ].map((item) => {
              const isSelected = exportFormat === item.key;
              return (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => setExportFormat(item.key)}
                  className={`py-3 px-4 rounded-xl border text-sm font-semibold transition font-poppins text-center cursor-pointer ${
                    isSelected
                      ? "bg-[#E8F2FF] border-[#B3D4FF] text-[#4B61FF]"
                      : "bg-[#F5F5F5] border-[#E2E8F0] text-[#4A5568] hover:bg-gray-100"
                  }`}
                >
                  {item.label}
                </button>
              );
            })}
          </div>

          <div className="border-t border-[#E2E8F0] my-4" />

          {/* Action Buttons */}
          <div className="flex gap-4 mt-6">
            <button
              type="button"
              onClick={() => setIsExportModalOpen(false)}
              className="flex-1 py-3 border border-[#D2D6DC] rounded-xl text-base font-semibold text-[#4A5568] hover:bg-gray-50 transition font-poppins cursor-pointer bg-white"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleExportConfirm}
              className="flex-1 py-3 btn-gradient text-white rounded-xl text-base font-semibold font-poppins cursor-pointer"
            >
              Export Data
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
